module.exports = __webpack_public_path__ + "static/media/natura2000.084a6f61.jpg";